"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var expressionsOfInterestStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        container: (_b = {
                marginBottom: '10px',
                textAlign: 'center',
                width: '100%'
            },
            _b[breakpoints.down('sm')] = {
                padding: '0 15px',
            },
            _b),
        title: {
            display: 'block',
            fontWeight: 700,
            marginBottom: '10px',
        },
        description: {
            display: 'block',
            marginBottom: '30px',
        },
        itemsWrapper: {
            justifyContent: 'center',
        },
    });
}, { name: 'GqlCheckout_ExpressionsOfInterest' });
exports.default = expressionsOfInterestStyles;
